import { Box, CancelButton, Skeleton, Typography } from "@crayon/design-system-react";
import { ConnectionState } from "api/client.generated";
import CloudIqConnectionForm from "components/hoc/Connections/Source/CloudIqConnectionForm";
import useCloudIqConfiguration from "hooks/api/useCloudIqConfiguration";
import usePartnerConnections from "hooks/api/usePartnerConnections";
import { useEffect, useState } from "react";
import MigratePartnerStepProps from "../MigratePartnerStepProps";

const SourceConnectionStep = ({ onStepComplete }: MigratePartnerStepProps) => {
  const { partnerConnections, isPartnerConnectionsFetching } = usePartnerConnections();
  const [ciqSourceEnabled, setCiqSourceEnabled] = useState(false);
  const { cloudIqConfig } = useCloudIqConfiguration();

  useEffect(() => {
    if (isPartnerConnectionsFetching || !partnerConnections) return;

    if (partnerConnections.configuredSources.CloudIq !== ConnectionState.RequestAccess)
      setCiqSourceEnabled(true);
  }, [partnerConnections, isPartnerConnectionsFetching, setCiqSourceEnabled]);

  if (isPartnerConnectionsFetching)
    return (
      <Box minWidth="500px" width="40%">
        <Skeleton variant="rounded" />
      </Box>
    );

  if (!ciqSourceEnabled) {
    return <Typography variant="body1">CloudIq source is not enabled for this partner</Typography>;
  }

  return (
    <Box minWidth="500px" width="40%">
      <CloudIqConnectionForm onSaveOk={onStepComplete} />
      {cloudIqConfig && (
        <CancelButton sx={{ mt: 2 }} onClick={onStepComplete} testId="skip-button">
          Skip
        </CancelButton>
      )}
    </Box>
  );
};

export default SourceConnectionStep;
